import { MappingDisplayItemTypes } from '../../enums/adjustments-and-reclasses/MappingDisplayItemTypes.enum';
import { IAdjustmentAndReclassesControlAddition } from '../../interfaces/adjustments-and-reclasses/IAdjustmentAndReclassesControlAddition.interface';
import { IMappingDisplayItemBasic } from '../../interfaces/adjustments-and-reclasses/IMappingDisplayItemBasic.interface';
import { RemoveReclassesHandler } from './RemoveReclassesHandler.type';

export type MappingDisplayItemWithForm = IMappingDisplayItemBasic &
    IAdjustmentAndReclassesControlAddition &
    (
        | {
              type: MappingDisplayItemTypes.ACCOUNT;
          }
        | {
              type: MappingDisplayItemTypes.RECLASSES;
              removeReclassesAccount: RemoveReclassesHandler;
          }
    );
